import { render, staticRenderFns } from "./course-opendots2.vue?vue&type=template&id=be308852&scoped=true&"
import script from "./course-opendots2.vue?vue&type=script&lang=js&"
export * from "./course-opendots2.vue?vue&type=script&lang=js&"
import style0 from "./course-opendots2.vue?vue&type=style&index=0&id=be308852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be308852",
  null
  
)

export default component.exports